import React, { useState } from 'react';
import SwitchIcon from './switch-icon';
import Modal from './modal';
import { api } from '../../../services/api';

function JsTag() {
  const [action, setAction] = useState(null);
  const [disableJstag, setDisableJstag] = useState(null);
  const [slug, setSlug] = useState('');
  const [displayMsg, setDisplayMsg] = useState('');
  const [response, setResponse] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  function onInputChange(e) {
    setSlug(e.target.value);
    setErrorMsg('');
    setAction(null);
  }

  function handleDisplayMsg(e, action) {
    e.preventDefault();
    if ((action === 'disable' || action === 'enable') && slug) {
      setDisplayMsg(`Are you sure you want to ${action} JStag for ${slug}?`);
    } else if (action === 'continue' && slug) {
      switchJsTagMode(slug, action);
      if (response) {
        setDisplayMsg(response);
      } else {
        setDisplayMsg('Please wait ...');
      }
    } else {
      setErrorMsg('Slug is required');
    }
  }

  async function switchJsTagMode(slug, disableJstag, action) {
    try {
      const data = await api.post(`/api/v0/jstags/${slug}/switch/${disableJstag}/`);
      setDisplayMsg(`Successfully ${action}d Jstag for ${slug}`);
      setResponse(data);
    } catch (err) {
      setDisplayMsg(err.message);
      setResponse(err);
    }
  }

  function clearState() {
    setAction(null);
    setDisableJstag(null);
    setSlug('');
    setDisplayMsg('');
    setResponse(null);
    setErrorMsg('');
  }

  const JsTagSwitchModal =
    action && slug ? (
      <Modal
        setAction={setAction}
        response={response}
        displayMsg={displayMsg}
        setDisableJstag={setDisableJstag}
        disableJstag={disableJstag}
        handleDisplayMsg={handleDisplayMsg}
        switchJsTagMode={switchJsTagMode}
        action={action}
        clearState={clearState}
        slug={slug}
      />
    ) : null;

  return (
    <div className="widgets js-tag">
      <h1>Manage JStag Mode</h1>
      <form className="input-form flex-column-center">
        <div className={`input-group ${errorMsg ? 'error' : ''}`}>
          <span className="error-message">{errorMsg}</span>
          <input
            className="input"
            name="slug"
            type="text"
            placeholder="Enter slug"
            value={slug}
            onChange={e => onInputChange(e)}
          />
        </div>
        <div className="flexbox-container">
          <button
            className="button disable"
            onClick={e => {
              setDisableJstag(true);
              setAction('disable');
              handleDisplayMsg(e, 'disable');
            }}
          >
            <SwitchIcon action="disable" />
            <span>DISABLE JSTAG</span>
          </button>

          <button
            className="button"
            action="enable"
            onClick={e => {
              setDisableJstag(false);
              setAction('enable');
              handleDisplayMsg(e, 'enable');
            }}
          >
            <SwitchIcon action="enable" />
            <span>ENABLE JSTAG</span>
          </button>
        </div>
      </form>
      {JsTagSwitchModal}
    </div>
  );
}

export default JsTag;
